// LoginPopup.js
import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import '../styles/LoginPopup.css';

const LoginPopup = ({ isOpen, onClose, onLogin, onGoogleLogin }) => {
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onLogin) {
            onLogin(identifier, password);
        }
        setIdentifier('');
        setPassword('');
        onClose();
    };

    const handleGoogleSuccess = (credentialResponse) => {
        console.log('Google login successful:', credentialResponse);
        if (onGoogleLogin) {
            onGoogleLogin(credentialResponse);
        }
        onClose();
    };

    const handleGoogleFailure = () => {
        console.log('Google login failed');
    };

    if (!isOpen) return null;

    return (
        <div className="login-popup-overlay" onClick={onClose}>
            <div className="login-popup" onClick={(e) => e.stopPropagation()}>
                <button className="close-button" onClick={onClose}>&times;</button>
                <h2>Connexion</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="identifier">Identifiant</label>
                        <input
                            type="text"
                            id="identifier"
                            value={identifier}
                            onChange={(e) => setIdentifier(e.target.value)}
                            placeholder="Votre identifiant"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Mot de passe</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Votre mot de passe"
                            required
                        />
                    </div>
                    <button type="submit" className="login-button">Se connecter</button>
                </form>
                <div className="separator">
                    <span>ou</span>
                </div>
                <div className="google-auth-section">
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={handleGoogleFailure}
                        useOneTap
                        auto_select
                    />
                </div>
                <div className="create-account">
                    <p>Pas de compte ? Créez-en un avec Google !</p>
                </div>
            </div>
        </div>
    );
};

export default LoginPopup;
